import { useTranslation } from 'react-i18next'
import { KibSuperSelect } from '@chewy/kib-fields-new-react'

import '@chewy/kib-fields-new-styles/dist/kib-fields-new.css'

const SYSTEM_USER_OPTION = {
  label: 'System',
  value: 'system',
}

export const KibSystemUserSelect = () => {
  const { t } = useTranslation('Common')

  return (
    <KibSuperSelect
      disabled
      label={t('Common:ASSIGNED')}
      options={[SYSTEM_USER_OPTION]}
      value={[SYSTEM_USER_OPTION]}
    />
  )
}
